import React, { PureComponent } from 'react';

import { Toggle } from 'components/toggle';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import { SUBTITLE_STATUS } from '../constants';
import SubtitleActions from '../SubtitleActions';

export default class SubtitleEnable extends PureComponent {
  static propTypes = {
    mediaId: PropTypes.string,
    status: PropTypes.string,
    id: PropTypes.string
  };

  get isActive() {
    return this.props.status === SUBTITLE_STATUS.ACTIVE;
  }

  render() {
    return (
      <div className="subtitle__enable">
        <label className="label__description">
          <I18n label="player_subtitles.enable_subtitle" />
        </label>
        <Toggle
          className="subtitle__enable__toggle _mb-0 _ml-2"
          checked={this.isActive}
          onChange={this.onChange}
        />
      </div>
    );
  }

  onChange = () => {
    const { status, mediaId, id } = this.props;

    SubtitleActions.toggleSubtitle(status, mediaId, id);
  };
}
